export default __webpack_public_path__ + "static/media/import_bill_water.38dd0b8a.xlsx";